
export const setFavicon = (url) => {
    if (!url) return;

    const link = document.querySelector("link[rel~='icon']");
    if (!link) {
        // If no favicon link exists, refrain from creating one to avoid potential issues
        // or create one if that's the desired behavior. For now, we'll assume one exists.
        return;
    }

    const image = new Image();
    image.crossOrigin = "Anonymous"; // Navigate CORS issues if any
    image.src = url;

    image.onload = () => {
        // Use a larger size for better quality on high-DPI screens
        const size = 64;
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");

        // Use high quality image smoothing
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        // Clear canvas
        ctx.clearRect(0, 0, size, size);

        // Calculate scale to contain the image, but do NOT upscale small images
        const scale = Math.min(1, size / image.width, size / image.height);

        // Center the image
        const dstWidth = image.width * scale;
        const dstHeight = image.height * scale;
        const x = (size - dstWidth) / 2;
        const y = (size - dstHeight) / 2;

        // Draw image centered
        ctx.drawImage(image, x, y, dstWidth, dstHeight);

        // Convert to data URL
        link.href = canvas.toDataURL("image/png");
    };

    image.onerror = () => {
        // Fallback or just ignore
        console.warn("Failed to load favicon image:", url);
    };
};
